import script from "./ExamList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamList.vue?vue&type=script&setup=true&lang=ts"

import "./ExamList.vue?vue&type=style&index=0&id=f29badea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f29badea"]])

export default __exports__